import axios from "axios";
import {API_CART_URL, LOGIN_CHECKOUT_URL} from "@/utils/api/Urls";

/**
 * Fetches cart details from the server based on the provided cart ID.
 * @param id The ID of the cart to fetch.
 * @returns The cart details of the specified cart.
 */
export const fetchCartById = async (id: number | string) => {
    const requestURL = `${LOGIN_CHECKOUT_URL}${API_CART_URL}/${id}`;

    try {
        const response = await axios.get(requestURL);
        return response.data as IProductDetails;
    } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
            if (err.response) {
                console.log("Error status:", err.response.status);
                return;
            }

            if (err.request) {
                console.log("No response received from server:", err.request);
                return;
            }
        }

        console.log("Non-Axios error occurred:", err);
    }
};
